import { mode } from '@chakra-ui/theme-tools';
var parts = ['container', 'control', 'label', 'icon'];

function baseStyleControl(props) {
  var {
    colorScheme: c
  } = props;
  var isCircle = props.variant === 'circle';
  return {
    w: '100%',
    transition: 'box-shadow 250ms',
    border: '1px solid',
    borderColor: mode('gray.700', 'transparent')(props),
    color: 'white',
    borderRadius: isCircle ? 'full' : 'sm',
    _checked: {
      bg: mode(c + ".500", c + ".100")(props),
      borderColor: mode(c + ".500", c + ".200")(props),
      color: mode('white', 'black')(props),
      _hover: {
        bg: mode(c + ".200", c + ".200")(props),
        borderColor: mode(c + ".200", c + ".200")(props)
      },
      _disabled: {
        borderColor: mode('gray.200', 'transparent')(props),
        bg: mode('gray.200', 'whiteAlpha.300')(props),
        color: mode('gray.200', 'whiteAlpha.500')(props)
      }
    },
    _indeterminate: {
      bg: mode(c + ".500", c + ".200")(props),
      borderColor: mode(c + ".500", c + ".200")(props),
      color: mode('white', 'black')(props)
    },
    _disabled: {
      bg: mode('gray.100', 'whiteAlpha.100')(props),
      borderColor: mode('gray.100', 'transparent')(props)
    },
    _focus: {
      boxShadow: 'none'
    },
    _invalid: {
      borderColor: mode('red.500', 'red.200')(props)
    }
  };
}

var baseStyleLabel = {
  userSelect: 'none',
  _disabled: {
    opacity: 0.4
  }
};

var baseStyle = props => ({
  control: baseStyleControl(props),
  label: baseStyleLabel
});

var sizes = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: 'sm'
    },
    icon: {
      fontSize: '0.45rem'
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: '0.5rem'
    }
  },
  lg: {
    control: {
      w: 6,
      h: 6
    },
    label: {
      fontSize: 'lg'
    },
    icon: {
      fontSize: '0.625rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
export default {
  parts,
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=Checkbox.js.map